import React from 'react';

export const TextTab = (): React.ReactElement => {
  return <div></div>;
};
